// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"23a5ce26","453":"2077be6a"}[chunkId] + ".chunk.js";
};